import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import DeviationSubmitPopup from '@wix/da-submit-shared/pkg/modals/DeviationSubmitPopup/DeviationSubmitPopup';
import SchedulePopup from '@wix/da-submit-shared/pkg/modals/SchedulePopup';
import ScheduleLimitReachedErrorModal from '@wix/da-submit-shared/pkg/modals/ScheduleLimitReachedErrorModal';
import AdditionalImagesPopup from '@wix/da-submit-shared/pkg/modals/AdditionalImagesPopup';
import { composeModalRenderers } from '@wix/da-shared-react/pkg/Modals/helpers';
import { adoptsModalRenderer } from '@wix/da-adopts-shared/pkg/project-tools';
import { muroModalRenderer } from '@wix/da-muro-ui/pkg/project-tools';
import { submitModalRenderer } from '@wix/da-submit-shared/pkg/project-tools';
import AttachmentUpsellModal from '@wix/da-submit-shared/pkg/modals/AttachmentUpsellModal';
import MainImagePopup from '@wix/da-submit-shared/pkg/modals/MainImagePopup';
import ProgressPopup from '@wix/da-submit-shared/pkg/modals/ProgressPopup';
import OriginalDeviationPopup from '@wix/da-submit-shared/pkg/modals/OriginalDeviationPopup';
import ArtsAndCraftsDeviationPopup from '@wix/da-submit-shared/pkg/modals/ArtsAndCraftsDeviationPopup';
import ManageShippingProfilesModal from '@wix/da-submit-shared/pkg/modals/ManageShippingProfilesModal';
import ShippingProfileEditModal from '@wix/da-submit-shared/pkg/modals/ShippingProfileEditModal';
import PresetsModal from '../../modals/PresetsModal';
import MobileBatchEdit from '../../modals/MobileBatchEdit';
import TierCreateModal from '../../modals/TierCreateModal';
import FolderModal from '../../modals/FolderModal';
import SellPrivateExclusiveConfirmation from '../../modals/SellPrivateExclusiveConfirmation';
import ScheduleBatchModal from '../../modals/ScheduleBatchModal';
import GalleryDisplaySettingsModal from '../../modals/GalleryDisplaySettingsModal';
import OriginalsOrderDetailsModal from '../../modals/OriginalsOrderDetailsModal';
import OriginalsDeclineModal from '../../modals/OriginalsDeclineModal';
import OriginalsDeclineSuccessModal from '../../modals/OriginalsDeclineSuccessModal';
import OriginalsAcceptSuccessModal from '../../modals/OriginalsAcceptSuccessModal';

export const studioModalRenderer = (modalType: string, requestClose: () => void, params?: any) => {
  switch (modalType) {
    case ModalType.DEVIATION_SUBMIT:
      return <DeviationSubmitPopup requestClose={requestClose} {...params} />;
    case ModalType.DEVIATION_SUBMIT_SCHEDULE:
      return <SchedulePopup requestClose={requestClose} {...params} />;
    case ModalType.DEVIATION_SUBMIT_SCHEDULE_LIMIT_REACHED:
      return <ScheduleLimitReachedErrorModal requestClose={requestClose} />;
    case ModalType.DEVIATION_SUBMIT_ADDITIONAL_IMAGES:
      return <AdditionalImagesPopup requestClose={requestClose} {...params} />;
    case ModalType.DEVIATION_SUBMIT_ADDITIONAL_IMAGES_UPSELL:
      return <AttachmentUpsellModal requestClose={requestClose} {...params} />;
    case ModalType.STUDIO_PRESETS:
      return <PresetsModal requestClose={requestClose} {...params} />;
    case ModalType.PROGRESS:
      return <ProgressPopup requestClose={requestClose} {...params} />;
    case ModalType.STUDIO_BATCH_EDIT:
      return <MobileBatchEdit requestClose={requestClose} {...params} />;
    case ModalType.STUDIO_TIER_CREATE:
      return <TierCreateModal />;
    case ModalType.STUDIO_FOLDER:
      return <FolderModal requestClose={requestClose} {...params} />;
    case ModalType.STUDIO_ORIGINALS_ORDER_DETAILS:
      return <OriginalsOrderDetailsModal onRequestClose={requestClose} {...params} />;
    case ModalType.STUDIO_ORIGINALS_DECLINE:
      return <OriginalsDeclineModal onRequestClose={requestClose} {...params} />;
    case ModalType.STUDIO_ORIGINALS_DECLINE_SUCCESS:
      return <OriginalsDeclineSuccessModal onRequestClose={requestClose} {...params} />;
    case ModalType.STUDIO_ORIGINALS_ACCEPT_SUCCESS:
      return <OriginalsAcceptSuccessModal onRequestClose={requestClose} {...params} />;
    case ModalType.DEVIATION_SUBMIT_MAIN_IMAGE_POPUP:
      return <MainImagePopup requestClose={requestClose} {...params} />;
    case ModalType.PRIVATE_SELL_CONFIRMATION:
      return <SellPrivateExclusiveConfirmation />;
    case ModalType.STUDIO_BATCH_SCHEDULE:
      return <ScheduleBatchModal requestClose={requestClose} {...params} />;
    case ModalType.ORIGINAL_DEVIATION:
      return <OriginalDeviationPopup onRequestClose={requestClose} {...params} />;
    case ModalType.ARTS_AND_CRAFTS_DEVIATION:
      return <ArtsAndCraftsDeviationPopup onRequestClose={requestClose} {...params} />;
    case ModalType.MANAGE_SHIPPING_PROFILES:
      return <ManageShippingProfilesModal onRequestClose={requestClose} {...params} />;
    case ModalType.SHIPPING_PROFILE_EDIT:
      return <ShippingProfileEditModal onRequestClose={requestClose} {...params} />;
    case ModalType.GALLERY_DISPLAY_SETTINGS:
      return <GalleryDisplaySettingsModal requestClose={requestClose} {...params} />;
    default:
      return null;
  }
};

export const composedModalRenderer = composeModalRenderers(
  adoptsModalRenderer,
  muroModalRenderer,
  submitModalRenderer,
  studioModalRenderer
);
